<!-- eslint-disable -->
<template>
  <span>
    {{calculatedLabelName}}
  </span>
</template>

<script>
/* eslint-disable */
export default {
  name: "c7OrgNameLabel",
  components: {},
  props: ["orgUid", "isNameNeeded"],
  data() {
    return {
      orgMetaData: {},
     isInitiailized: false
    };
  },
  mounted() {
    this.$nextTick(function(){
      this.startListener();
    });
  },
  methods: {
    startListener() {
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (window.vue_instance.$data.watchdog.watchdogDbConnected === true && typeof this.orgUid === 'string') {
        window.G_watchdog_data.initOrgMetaDataListener(this.orgUid);
        this.orgMetaData= window.G_watchdog_data.IV_org_meta_data;
        this.isInitiailized = true;
      } else {
        setTimeout(this.startListener, 200);
      }
    }
  },
  beforeDestroy() {
    // TODO adding key with listener to track which components are using metadata.
    // window.G_watchdog_data.bi7UnsubscribeSpecificListener('org_meta_data', this.orgUid);
  },
  computed: {
    calculatedLabelName() {
      if (this.isInitiailized === true &&
          this.orgUid !== null && this.orgUid !== undefined && 
          this.orgUid in this.orgMetaData &&
          this.orgMetaData[this.orgUid] !== null &&
          this.orgMetaData[this.orgUid] !== undefined &&
          'name' in this.orgMetaData[this.orgUid]) {
        return this.orgMetaData[this.orgUid]['name']
      } else if (this.orgUid !== null && this.orgUid !== undefined && 
                 this.orgMetaData[this.orgUid] !== null &&
                 this.orgMetaData[this.orgUid] !== undefined &&
                (this.orgUid in this.orgMetaData === false ||
                'name' in this.orgMetaData[this.orgUid] === false)) {
        return `Loading: ${this.orgUid}`
      } else {
        return "Loading..."
      }
    }
  },
  watch: {
    orgMetaData() {
      if (this.isNameNeeded === undefined || this.isNameNeeded === false) {
        return;
      }
      if (this.orgUid !== null && this.orgUid !== undefined && 
          this.orgUid in this.orgMetaData && 
          'name' in this.orgMetaData[this.orgUid]) {
        var name = this.orgMetaData[this.orgUid]['name'];
        this.$emit("event-org-name-changed", name);
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Labels/c7OrgNameLabel.vue